<template>
	<div class="spinner-elem flex items-center justify-center">
		<div class="border-primary h-10 w-10 animate-spin rounded-full border-b-2 border-t-2"></div>
	</div>
</template>
